import { CarrierPage } from "./CarrierPage";

const Carrier = () => {
	return <CarrierPage />;
};
export default Carrier;
